exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/components/sidebar/sidebar.component.css
// module id = ../../../../../src/app/components/sidebar/sidebar.component.css
// module chunks = main